exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".takipiScrollbarVerticalTrack{background:transparent}.takipiScrollbarVerticalThumb{cursor:default!important;border-radius:5px!important;width:5px!important;background-color:#5c656e!important;opacity:.7}", ""]);

// exports
